import { AdminApi } from '@guiker/real-estate-shared'
import { TypeOf, yup } from '@guiker/yup-util'

export const updateListingPropertyBuildingSchema = yup.object({
  property: AdminApi.Schema.updatePropertyBuildingAddressSchema,
})

export type UpdateListingPropertyBuildingSchema = TypeOf<typeof updateListingPropertyBuildingSchema>
